import React from 'react';
import ConnectorCard from '../Components/Connector/ConnectorCard';

const Users = () => (
  <ConnectorCard title="Integrations" />
);

export default Users;
